import { gql } from '@apollo/client';

import { Course } from '../../types';
import { CourseFormInput } from '../../types/form';
import { courseFragment } from '../fragments';

export interface CreateCourseMutationVariables {
  input: CourseFormInput;
}

export interface CreateCourseMutationResult {
  course: Course;
}

export const createCourseMutation = gql`
  mutation CreateCourse($input: CreateCourseInput!) {
    course(input: $input) @rest(type: "Course", path: "courses", method: "POST") {
      ...Course
    }
  }
  ${courseFragment}
`;
